import dicomParser from 'dicom-parser';
import cornerstone from 'cornerstone-core';
import Hammer from 'hammerjs';
const cornerstoneWADOImageLoader = require("cornerstone-wado-image-loader");
const cornerstoneWebImageLoader = require("cornerstone-web-image-loader");
const cornerstoneMath = require("cornerstone-math");
const cornerstoneTools = require("cornerstone-tools");

export default function initCornerstone():void {
    // Cornertone Tools
    cornerstoneTools.external.cornerstone = cornerstone;
    cornerstoneTools.external.Hammer = Hammer;
    cornerstoneTools.external.cornerstoneMath = cornerstoneMath;
    // Create the synchronizer
    const synchronizer = new cornerstoneTools.Synchronizer(
        // Cornerstone event that should trigger synchronizer
        'cornerstonenewimage',
        // Logic that should run on target elements when event is observed on source elements
        cornerstoneTools.updateImageSynchronizer
    )
    cornerstoneTools.addTool(cornerstoneTools.ReferenceLinesTool);
    cornerstoneTools.setToolEnabled('ReferenceLines', {
      synchronizationContext: synchronizer,
    });


    //
    cornerstoneTools.init();

    // Preferences
    const fontFamily =
        'Work Sans, Roboto, OpenSans, HelveticaNeue-Light, Helvetica Neue Light, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif';
    cornerstoneTools.textStyle.setFont(`16px ${fontFamily}`);
    cornerstoneTools.toolStyle.setToolWidth(2);
    cornerstoneTools.toolColors.setToolColor('rgb(255, 255, 0)');
    cornerstoneTools.toolColors.setActiveColor('rgb(0, 255, 0)');

    cornerstoneTools.store.state.touchProximity = 40;


    // IMAGE LOADER

    cornerstoneWADOImageLoader.external.cornerstone = cornerstone;
    cornerstoneWADOImageLoader.external.dicomParser = dicomParser;
    cornerstoneWADOImageLoader.webWorkerManager.initialize({
        maxWebWorkers: navigator.hardwareConcurrency || 1,
        startWebWorkersOnDemand: true,
        taskConfiguration: {
            decodeTask: {
                initializeCodecsOnStartup: false,
                usePDFJS: false,
                strict: false,
            },
        },
    });

    // JPEG IMAGE LOADER
    cornerstoneWebImageLoader.external.cornerstone = cornerstone;
 

    // Debug
    (window as any).cornerstone = cornerstone;
    (window as any).cornerstoneTools = cornerstoneTools;
}


